export const colors = {
  mainPurple: "#43387a",
  mainOrange: "#ff7a0f",
  subPurple5: "#4c4294",
  subPurple4: "#6353c0",
  subPurple3: "#7d6ed3",
  subPurple2: "#e4e0fa",
  subPurple1: "#f9f8ff",
  subOrange5: "#ff8f33",
  subOrange4: "#ffaa66",
  subOrange3: "#ffc799",
  subOrange2: "#ffe3cc",
  subOrange1: "#fff9f5",
  subBody3: "#505a71",
  subBody2: "#aaafb9",
  subBody1: "#eceff6",
  black: "#1e2328",
  dimBg: "#f9fafb",
  dimGray: "#E3E5E8",
  white: "#ffffff",
  darkGray2: "#62626b",
  darkGray1: "#9a9aa3",
  gray: "#c6c6ce",
  lightGray2: "#e1e1e5",
  lightGray1: "#e8e8ed",
  statusInfo: "#111111",
  statusSuccess: "#5a5380",
  statusError: "#ff4a26",

  disabledBg: "#F5F5F7", // 피그마엔 없음 (체크박스,라디오버튼 비활성화 배경 값)
};
